import { GET, rawPOST } from "services/httpService";
import { getAppConfig } from "services/configService";

const apiUrl = () => {
  return getAppConfig().XServerUrl;
};

export const getSavedProjects = async (requestInfo, accountId, pageNumber = 1, pageSize = 10) => {
  const offset = (pageNumber - 1) * pageSize;
  const response = await GET(
    requestInfo,
    apiUrl() +
      `/XServerWebApi/StoredProductsV2/PagedItems?format=json&detailed=true&limit=10&offset=${offset}&accountId=${accountId}`
  );
  return response;
};

export const doDeleteProject = async (requestInfo, projectId) => {
  var url = apiUrl() + `/XServerWebApi/products/${projectId}/?X-HTTP-Method-Override=DELETE&format=xml`;
  const res = await rawPOST(requestInfo, url, "<delete/>");

  if (!res.ok) {
    throw new Error(await res.text());
  }

  return res.text();
};
